<template>
  <b-container style="max-width: 40rem;">
    <b-overlay :show="loading">
      <b-row class="mt-3">
        <b-col>
          <b-form v-on:submit.prevent="onSubmit">
            <b-form-group id="input-group-1"
                          label="Gebruikersnaam:"
                          label-for="input-1"
                          style="margin-top:1%">
              <b-form-input id="input-1"
                            v-model="form.username"
                            placeholder="Gebruikersnaam"
                            required />
            </b-form-group>

            <b-form-group id="input-group-2"
                          label="Wachtwoord:"
                          label-for="input-2"
                          style="margin-top:1%">
              <b-form-input id="input-2"
                            v-model="form.password"
                            type="password"
                            placeholder="Wachtwoord"
                            required />
            </b-form-group>

            <b-form-invalid-feedback :state="succesfullLogin">
              Gebruiker niet gevonden controleer uw gebruikersnaam en/of wachtwoord.
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="succesfullLogin">
              Succesvol ingelogd.
            </b-form-valid-feedback>
            <b-row>
              <b-col cols="1" style="margin-top:3%">
                <b-button type="submit" variant="primary">Inloggen</b-button>
              </b-col>
              <!--<b-col cols="5" offset="2" style="margin-top:3%">
                <b-button type="forgot" variant="primary">Wachtwoord vergeten</b-button>
              </b-col>-->
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>

  export default {
    name: 'Login',
    data() {
      return {
        form: {
          username: '',
          password: '',
        },
        succesfullLogin: null,
        loading: false
      }
    },
    methods: {
      async onSubmit() {
        this.loading = true
        var result = await this.$authService.login(this.form)
        this.loading = false
        this.succesfullLogin = result
        this.$router.push({ name: 'home' })
      }
    }
  }
</script>

<style scoped>
  a.disabled {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue